<template>
  <div class="project-item">
    <h4>{{ item.name }}</h4>
    <div class="project-item__type">
      <div class="project-item__row secondary_text">
        Тип проекта:
        <span class="secondary_text_slim">{{ item.type }}</span>
      </div>
    </div>
    <div class="project-item__briefcase secondary_text">
      Портфель:
      <span class="secondary_text_slim">{{ item.briefcases.join(', ') }}</span>
    </div>
    <div class="project-item__row secondary_text">
      Роль в проекте:
      <span class="secondary_text_slim">{{ getRoles() }}</span>
    </div>
    <div class="project-item__date secondary_text">
      {{ getDates() }}
    </div>
  </div>
</template>

<script setup>
  import dayjs from 'dayjs';
  import updateLocale from 'dayjs/plugin/updateLocale';

  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
  });

  const getRoles = () => {
    return props.item?.roles.join(', ');
  };

  const getDates = () => {
    dayjs.extend(updateLocale);
    dayjs.updateLocale('ru', {
      monthsShort: [
        'янв',
        'фев',
        'мар',
        'апр',
        'май',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек',
      ],
    });

    const startDj = dayjs(props.item.startDate).locale('ru');
    const endDj = dayjs(props.item.endDate).locale('ru');

    if (startDj.year() === endDj.year()) {
      const monthStart = startDj.format('MMM').toLowerCase();
      const monthEnd = endDj.format('MMM').toLowerCase();
      return `${monthStart} ${startDj.year()} - ${monthEnd} ${endDj.year()}`;
    } else {
      return `${startDj.year()} - ${endDj.year()}`;
    }
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors' as *;

  .project-item {
    background: $color-bg-primary-white;
    border-radius: 6px;
    padding: 20px;
    display: flex;
    flex-direction: column;

    h4,
    &__type,
    &__briefcase {
      margin: 0 0 16px 0;
    }

    &__date {
      margin: 40px 0 0 0;
    }
  }

  .secondary_text {
    font-family: Nunito Sans, sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: $color-text-secondary-grey-profile;

    &_slim {
      font-weight: 400;
    }
  }
</style>
